/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../Button"));

var _join = _interopRequireDefault(require("../../../common/join"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ICON_CLASS_NAME = 'inovua-react-pagination-toolbar__icon';

var PaginationIcon = function (_React$Component) {
  (0, _inherits2.default)(PaginationIcon, _React$Component);

  var _super = _createSuper(PaginationIcon);

  function PaginationIcon() {
    (0, _classCallCheck2.default)(this, PaginationIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PaginationIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          size = _this$props.size,
          disabled = _this$props.disabled,
          action = _this$props.action,
          name = _this$props.name,
          theme = _this$props.theme;
      var className = (0, _join.default)(ICON_CLASS_NAME, "".concat(ICON_CLASS_NAME, "--named--").concat(name));
      return _react.default.createElement(_Button.default, {
        disabled: disabled,
        className: className,
        icon: (0, _react.cloneElement)(icon, {
          width: size,
          height: size
        }),
        onClick: action,
        theme: theme
      });
    }
  }]);
  return PaginationIcon;
}(_react.default.Component);

exports.default = PaginationIcon;
PaginationIcon.propTypes = {
  name: _propTypes.default.string,
  action: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.node,
  size: _propTypes.default.number
};